import { render, staticRenderFns } from "./ItemPotential.vue?vue&type=template&id=3096398e&scoped=true&"
import script from "./ItemPotential.vue?vue&type=script&lang=js&"
export * from "./ItemPotential.vue?vue&type=script&lang=js&"
import style0 from "./ItemPotential.vue?vue&type=style&index=0&id=3096398e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096398e",
  null
  
)

export default component.exports